import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon, MapPinIcon } from 'lucide-react';
export function AuthoritySection() {
  const whatsappLink = 'https://wa.me/17863975041?text=Hola%20Ricmary%2C%20me%20gustar%C3%ADa%20orientaci%C3%B3n%20sobre%20seguro%20de%20vida%20en%20EE.UU.%20%28en%20espa%C3%B1ol%29.%20Tengo%20%5BTU%20EDAD%5D%20a%C3%B1os%20y%20vivo%20en%20%5BTU%20ESTADO%5D.%20%C2%BFMe%20ayudas%20a%20entender%20qu%C3%A9%20opci%C3%B3n%20me%20conviene%3F';
  return <section className="bg-white py-20 px-6" data-id="element-8">
      <div className="max-w-4xl mx-auto" data-id="element-9">
        <div className="text-center mb-12" data-id="element-10">
          <h2 className="font-heading text-3xl md:text-4xl text-navy font-bold" data-id="element-11">
            ¿Quién te guía?
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto mt-4 rounded-full" data-id="element-12" />
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-cream rounded-3xl p-8 md:p-12 shadow-soft flex flex-col md:flex-row gap-8 items-center md:items-start" data-id="element-13">
          {/* Agent Photo */}
          <div className="w-48 h-48 md:w-56 md:h-56 flex-shrink-0 rounded-full overflow-hidden border-4 border-white shadow-lg relative" data-id="element-14">
            <img src="https://cdn.magicpatterns.com/uploads/1JwSqBnUNn8dkP6XiEPJMv/IMG_2060.png" alt="Ricmary Barcenas - Licensed Insurance Producer" className="w-full h-full object-cover object-top" data-id="element-15" />
          </div>

          {/* Agent Info */}
          <div className="flex-1 text-center md:text-left" data-id="element-16">
            <h3 className="font-heading text-2xl md:text-3xl text-navy font-bold mb-1" data-id="element-17">
              RB Protection | Ricmary Barcenas
            </h3>
            <p className="text-gold-dark font-semibold mb-4 text-lg" data-id="element-18">
              Licensed Insurance Producer – Life
            </p>

            <div className="flex items-start justify-center md:justify-start gap-2 text-sm text-gray-600 mb-6 bg-white/50 inline-flex px-4 py-2 rounded-lg" data-id="element-19">
              <MapPinIcon className="w-4 h-4 mt-0.5 flex-shrink-0 text-navy" data-id="element-20" />
              <p data-id="element-21">Licenciada en: CA, OH, NM, NJ, SC, FL, TX, AZ</p>
            </div>

            <p className="text-gray-700 text-lg leading-relaxed mb-8" data-id="element-22">
              Mi trabajo es ayudarte a entender el seguro de vida en EE.UU. con
              claridad y acompañarte para que tomes una decisión informada: lo
              que necesitas, al precio que tenga sentido, y sin confusión.
            </p>

            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-navy hover:bg-navy-light text-white px-6 py-3 rounded-xl font-medium transition-colors" data-id="element-23">
              <MessageCircleIcon className="w-5 h-5" data-id="element-24" />
              Quiero orientación por WhatsApp
            </a>
          </div>
        </motion.div>

        {/* Backing / Logo */}
        <div className="mt-12 flex flex-col items-center opacity-70 hover:opacity-100 transition-opacity" data-id="element-25">
          <p className="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-3" data-id="element-26">
            Respaldo
          </p>
          <img src="https://cdn.magicpatterns.com/uploads/1eLdoLQgU8dwEpFk3PXX8K/IMG_4044.webp" alt="Senior Life Insurance Company" className="h-16 w-auto grayscale hover:grayscale-0 transition-all duration-300" data-id="element-27" />
        </div>

        {/* Disclaimer */}
        <div className="mt-16 text-center" data-id="element-28">
          <p className="text-xs text-gray-400 max-w-2xl mx-auto" data-id="element-29">
            Contenido educativo. La elegibilidad, condiciones y costos dependen
            de edad, salud, estado y suscripción de la aseguradora.
          </p>
        </div>
      </div>
    </section>;
}